var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.544 3.965a3.13 3.13 0 00-4.413.353l-3.61 4.236a4.985 4.985 0 107.59 6.466l4.572-5.366a.58.58 0 01.883.752l-4.572 5.366a6.145 6.145 0 01-9.355-7.97l3.61-4.236a4.29 4.29 0 116.53 5.564l-3.609 4.236a2.435 2.435 0 11-3.706-3.158l3.609-4.236a.58.58 0 11.882.752L8.346 10.96a1.275 1.275 0 001.942 1.654l3.609-4.236a3.13 3.13 0 00-.353-4.413z"
  })));
}
export default SvgReplyAttachment;